import { DeleteFilled } from "@ant-design/icons";
import { Form, Upload } from "antd";
import "antd/dist/antd.min.css";
import PropTypes from "prop-types";
import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import ButtonField from "../../../common/htmlComponents/ButtonField";
import UploadFileIcon from "../../../image/AddCsv.png";
import FileAltLabel from "../../../image/DownloadSample.svg";
import "../../../styles/Main.scss";
const BulkSectorUpload = ({
  newSectorAdded,
  setNewSectorAdded,
  handleCancelBulk,
}) => {
  const { t } = useTranslation();
  const { Dragger } = Upload;
  const [uploadFile, setUploadFile] = useState("");
  const [fileName, setFileName] = useState(null);

  const formRef = useRef();

  //  Function to handle cancellation and reset form
  const backToList = () => {
    handleCancelBulk();
    handleDeleteFile();
  };

  // Function to Delete the File 
  const handleDeleteFile = () => {
    setUploadFile("");
    setFileName(null);
  };

  // function for uploading CSV file
  const uploadProps = {
    accept: ".csv",
    showUploadList: false,
    beforeUpload: (file) => {
      setUploadFile(file);
      setFileName(file.name);
      return false;
    },
  };

  return (
    <div className="uploadwrap">
      <div className="uploadinside">
        <div className="ImportCSV">
          <Form className="ModalForm" autoComplete="off" ref={formRef}>
            <Dragger {...uploadProps}>
              <div className="AddCssIcon">
                <Link>
                  {" "}
                  <img
                    className="BulkDownload"
                    src={UploadFileIcon}
                    alt=""
                  />{" "}
                </Link>
              </div>

              <h2>Drag and drop your CSV file here</h2>
              <h3>Or select file your computer</h3>
            </Dragger>
            <div className="UploadedFileIcon">
              {fileName}

              {uploadFile && (
                <DeleteFilled
                  className="DeleteGradiantBtn"
                  label="Delete"
                  onClick={handleDeleteFile}
                />
              )}
            </div>

            <div className="DnlSempleFile">
              <h2>Download Sample File From Here</h2>
              <span>
                {" "}
                <a
                  className="link-color"
                >
                  <img className="BulkDownloadIcon" src={FileAltLabel} alt="" />{" "}
                  Get CSV Sample
                </a>
              </span>
            </div>

            <div className="ModalPopupFooter mt-0">
              <ButtonField
                className="CancelGradiantBtn"
                type="primary"
                htmlType="button"
                label={t("cancel")}
                onClick={backToList}
              />

              <ButtonField
                className="SaveGradiantBtn"
                label={t("import")}
                htmlType="Submit"
              />
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
};

BulkSectorUpload.propTypes = {
  handleCancelBulk: PropTypes.func.isRequired,
  newSectorAdded: PropTypes.bool.isRequired,
  setNewSectorAdded: PropTypes.func.isRequired,
};

export default BulkSectorUpload;
